export default function popupDuration(contentLength: number) {
  if (contentLength <= 20) {
    return 3000;
  } else {
    return 5000;
  }
}
